import { ErrorPage } from '@mysaiva/core'

/**
 * Screen shown when user tries to access a product they don't have permission for
 */
export function UnauthorizedProductScreen() {
  return <ErrorPage />
}
